import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useBrands } from "@/hooks/use-brands";
import { Skeleton } from "@/components/ui/skeleton";
import { clearLastBrandSlug, homePathFor, readLastBrandSlug } from "@/lib/last-brand";

/**
 * App root (`/`). Reopens the brand the user was last on, so opening Pilot
 * lands straight in their workspace. `/dashboard` stays reachable directly for
 * the all-brands view.
 */
export function HomeRedirect() {
  const { data: brands, isLoading, isError } = useBrands();
  const lastSlug = readLastBrandSlug();
  const slugs = brands?.map((b) => b.slug) ?? [];
  const staleSlug = !!brands && !!lastSlug && !slugs.includes(lastSlug);

  // The remembered brand was deleted or access was removed — forget it.
  useEffect(() => {
    if (staleSlug) clearLastBrandSlug();
  }, [staleSlug]);

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="space-y-3 w-64">
          <Skeleton className="h-6 w-48" />
          <Skeleton className="h-4 w-full" />
        </div>
      </div>
    );
  }

  if (isError || !brands) return <Navigate to="/dashboard" replace />;
  return <Navigate to={homePathFor(slugs, lastSlug)} replace />;
}
